import { render, staticRenderFns } from "./FileMenu.vue?vue&type=template&id=e2a73c70&"
import script from "./FileMenu.vue?vue&type=script&lang=js&"
export * from "./FileMenu.vue?vue&type=script&lang=js&"
import style0 from "./FileMenu.vue?vue&type=style&index=0&id=e2a73c70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports